import { clsx } from 'clsx';
import Skeleton from 'react-loading-skeleton';
import { Swiper, SwiperSlide } from 'swiper/react';

import { OperatorsWithStatuses } from '@/types';

import cn from './styles.module.sass';

interface IOperatorsProps {
    operatorsIconsNames: OperatorsWithStatuses;
    onClick?: (id: number) => void;
    isLoading?: boolean;
}

export const Operators = ({ operatorsIconsNames, onClick, isLoading }: IOperatorsProps) => {
    return (
        <div className={cn.container}>
            <Swiper slidesPerView="auto" spaceBetween={4}>
                {isLoading ? (
                    <Skeleton
                        count={7}
                        width={44}
                        height={38}
                        containerClassName={cn.operatorsSkeletonContainer}
                    />
                ) : (
                    operatorsIconsNames.map(item => (
                        <SwiperSlide
                            onClick={onClick?.bind(null, item.id)}
                            className={clsx(cn.slide, item.active && cn.active)}
                            key={item.id}
                        >
                            <img src={`/images/icons/operators/${item.name}.svg`} alt="" />
                        </SwiperSlide>
                    ))
                )}
            </Swiper>
        </div>
    );
};
